<template>
  <div class="features-list">
    <v-chip
      v-for="(feature, index) in features"
      :key="index"
      class="mr-2 mb-2"
      label
      :color="primary ? 'orange' : 'orange-light'"
      :text-color="primary ? 'white' : ''"
    >
      <template v-if="isString(feature)">
        {{ feature }}
      </template>
      <template v-else>
        {{ objectToString(feature) }}
      </template>
    </v-chip>

    <EditBtn  v-if="editable" class="mr-2" @click="editFeatures" />
  </div>
</template>

<script>
import EditBtn from '@/components/Developers/Show/EditBtn.vue';

export default {
  components: {
    EditBtn,
  },

  props: {
    features: {
      type: Array,
      required: true,
    },

    primary: {
      type: Boolean,
      required: false,
      default: false,
    },

    editable: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  methods: {
    isString(element) {
      return typeof element === 'string' || element instanceof String;
    },

    objectToString(element) {
      return Object.values(element).join(' ');
    },

    editFeatures() {
      this.$emit('edit');
    },
  },
};
</script>
